import React, { FC } from 'react'

type Props = {
  videoSrc: string
  videoType: string
  width: number
  height: number
  youtubeID: string
}

const WrapperVideo: FC<Props> = ({ videoSrc, videoType, width, height, youtubeID }) => {
  const youtubeURL = 'https://www.youtube.com'

  return youtubeID ? (
    <iframe
      data-cy="WrapperVideo"
      src={`${youtubeURL}/embed/${youtubeID}`}
      width={width}
      height={height}
    />
  ) : (
    <video width={width} data-cy="WrapperVideo" controls>
      <source src={videoSrc} type="video/webm" />
      <source src={videoSrc} type="video/mp4" /> {/* fallback for older browser versions */}
    </video>
  )
}

export default WrapperVideo
